import * as React from 'react';
import { Body1, Body2, Responsive } from '@cian/ui-kit';

import { IPromotionCell } from '../../../../../../types/newbuildingsCompare';
import * as styles from './styles.css';

export interface IPromotionCellProps {
  cell: IPromotionCell;
}

export const PromotionCell = ({ cell }: IPromotionCellProps): React.JSX.Element => {
  if (!cell.data?.items?.length) {
    return (
      <div className={styles['container']}>
        <Body1 color="text-primary-disabled">{cell.state.text ?? ''}</Body1>
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      {cell.data.items.map((item, index) => (
        <Body1 key={index}>{item}</Body1>
      ))}
      {cell.data.countText && (
        <span className={styles['count-text-container']}>
          <Responsive desktop>
            <Body1>{cell.data.countText}</Body1>
          </Responsive>
          <Responsive phone tablet>
            <Body2>{cell.data.countText}</Body2>
          </Responsive>
        </span>
      )}
    </div>
  );
};
